import { Pipe, PipeTransform } from '@angular/core'
import { centToString } from '@adex/shared/utils/view'


@Pipe({
  name: 'moneyFormatter',
  pure: true
})
export class MoneyFormatterPipe implements PipeTransform {

  public transform(value: string | number): string {
    const v = centToString(value)
    return `${ v[0] === '-' ? v : `+${ v }` }$`
  }

}
